const RUNTIME_SCHEMA_DATA_KEYS = [
  "data",
  "widgetData",
  "cachedData",
  "dataCache",
];

const RUNTIME_WIDGET_DATA_KEYS = [
  "data",
  "widgetData",
  "cachedData",
  "dataCache",
  "result",
  "payload",
  "response",
];

const omitKeys = (source, keys) => {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return source;
  }

  const blocked = new Set(keys);
  return Object.fromEntries(
    Object.entries(source).filter(([key]) => !blocked.has(key)),
  );
};

export function sanitizeReportSchemaForRuntime(schema) {
  if (Array.isArray(schema)) {
    return schema.map((item) => sanitizeReportSchemaForRuntime(item));
  }

  if (!schema || typeof schema !== "object") {
    return schema;
  }

  const sanitized = omitKeys(schema, RUNTIME_SCHEMA_DATA_KEYS);

  if (Array.isArray(schema.widgets)) {
    sanitized.widgets = schema.widgets.map((widget) =>
      omitKeys(widget, RUNTIME_WIDGET_DATA_KEYS),
    );
  }

  return sanitized;
}

